import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

function getPlaceLabel({ place, isChip }: { place: Filters['place'], isChip?: boolean }) {
  if (place?.name) {
    return place.name
  }

  const commonStore = useCommonStore()

  if (isChip) {
    return commonStore.doctorList.hasMetro
      ? 'Метро'
      : ''
  }

  return commonStore.doctorList.hasMetro
    ? 'Метро, район'
    : 'Район'
}

export default getPlaceLabel
